const ajax = require('component-ajax');
const cookie = require('cookie-cutter');
const EventEmitter = require('events');
const q = require('queried');
const delegate = require('emmy/delegate');
const sample = require('lodash/sample');
const domify = require('domify');
const {
  showLoginPopup,
  getIcon,
  showGrecaptchaPopup,
} = require('../utils');

const ID_ATTRIBUTE = 'data-ping-item-id';
const TYPE_ATTRIBUTE = 'data-ping-item-type';
const VOTE_ATTRIBUTE = 'data-voted';
const VOTES_NUMBER_ATTRIBUTE = 'data-votes-number';
const TOTAL_VOTES_NUMBER_ATTRIBUTE = 'data-total-votes-number';
const VOTES_PERCENT_ATTRIBUTE = 'data-votes-percent';

const PHRASES = [
  {
    title: 'Спасибо!',
    body: 'Проголосуйте за лучшего в номинации «%s»',
    button: 'Далее',
  },
  {
    title: 'Отличный выбор!',
    body: 'Выберите лучшего в категории «%s»',
    button: 'Далее',
  },
  {
    title: 'Спасибо за ваш голос',
    body: 'Ознакомьтесь с номинантами премии «%s»',
    button: 'Далее',
  },
];

function getNextCategory() {
  const nextLink = q('.awardTitle-nav--next');
  return {
    name: q('span', nextLink).textContent,
    url: nextLink.href,
  };
}

class VotingItem extends EventEmitter {
  constructor(element) {
    super();
    this.type = element.getAttribute(TYPE_ATTRIBUTE);
    this.id = element.getAttribute(ID_ATTRIBUTE);
    this.number = Number(element.getAttribute(VOTES_NUMBER_ATTRIBUTE));
    this.percent = parseFloat(element.getAttribute(VOTES_PERCENT_ATTRIBUTE));
    this.totalVotes = parseFloat(element.getAttribute(TOTAL_VOTES_NUMBER_ATTRIBUTE));
    this.bindSubmitButtonClick();
    this.bindCloseButtonClick();

    const content = domify(`
      <div class="voting">
          <span class="voting-check"></span>
          <span class="button button--golden voting-button">
          Голосовать
        </span>
        <div class="voting-count">
          ${getIcon('vote')}
            <span class="voting-countContent"></span>
        </div>
      </div>
    `);

    // mobile version doesn't have '.post-footer' element
    (q('.post-footer', element) || element).appendChild(content);
    this.appendPopup();
    this.createConfirmEmailPopup();
  }

  appendPopup() {
    const next = getNextCategory();
    const phrases = sample(PHRASES);
    this.getElement().appendChild(domify(`
      <div class="votingPopup">
        <div class="awardPopup-close">
          ${getIcon('close')}
        </div>
        <div class="votingPopup-title">
            <span>
            ${phrases.title}
          </span>
        </div>
        <div class="votingPopup-content">
          ${phrases.body.replace('%s', next.name)}
          <div>
            <a href="${next.url}" class="button button--golden">
              ${phrases.button}
            </a>
          </div>
        </div>
      </div>
    `));
  }

  createConfirmEmailPopup() {
    this.getElement().appendChild(domify(`
      <div class="confirmEmailPopup">
        <div class="awardPopup-close">
          ${getIcon('close')}
        </div>
        <div class="confirmEmailPopup-content">
          Пожалуйста, подтвердите свой e-mail,
          чтобы проголосовать.
          Для того, чтобы выслать письмо о подтверждении ещё раз <a href="/account/settings">нажмите сюда</a>.
        </div>
      </div>
    `));
  }

  isLoggedIn() {
    return window.kudago.user && window.kudago.user.isAuthenticated;
  }

  isConfirmed() {
    return window.kudago.user && window.kudago.user.isConfirmed;
  }

  isVoted() {
    return !!this.getElement().getAttribute(VOTE_ATTRIBUTE);
  }

  isDisabled() {
    return !!this.getElement().getAttribute('data-disabled');
  }

  sendRequest(url) {
    if (document.body.classList.contains('body--votingPageFinished')) {
      return Promise.reject();
    }
    return new Promise((resolve, reject) => {
      ajax({
        type: 'POST',
        url,
        headers: {
          'X-CSRFToken': cookie.get('csrftoken'),
        },
        data: {
          type: this.type,
          id: this.id,
          'g-recaptcha-response': this.gRecaptchaResponse,
        },
        success: resolve,
        error: reject,
      });
    });
  }

  get gRecaptchaResponse() {
    return JSON.parse(window.localStorage.getItem('gRecaptchaResponse'));
  }

  set gRecaptchaResponse(value) {
    window.localStorage.setItem('gRecaptchaResponse', JSON.stringify(value));
  }

  activate() {
    if (this.isVoted() || this.isDisabled()) {
      return;
    }
    const toVoteWithCaptcha = () => this.toVote().catch(() => {
      this.gRecaptchaResponse = null;
      this.activate();
    });
    if (this.isLoggedIn() && this.isConfirmed()) {
      if (this.gRecaptchaResponse) {
        toVoteWithCaptcha();
      } else {
        showGrecaptchaPopup((gRecaptchaResponse) => {
          this.gRecaptchaResponse = gRecaptchaResponse;
          return toVoteWithCaptcha();
        });
      }
    } else if (this.isLoggedIn() && !this.isConfirmed()) {
      this.showConfirmEmailPopup();
    } else {
      showLoginPopup({
        reason: 'vote',
      });
    }
  }

  toVote() {
    return this.sendRequest('/votes/add/').then(() => {
      this.getElement().setAttribute(VOTE_ATTRIBUTE, true);
      this.totalVotes += 1;
      this.number += 1;
      this.percent = this.number / this.totalVotes * 100;
      this.emit('change');
    });
  }

  showConfirmEmailPopup() {
    q.all('.show-confirm-popup').forEach((el) => el.classList.remove('show-confirm-popup'));
    q.all('.awardPopup--hidden').forEach((el) => el.classList.remove('awardPopup--hidden'));
    this.getElement().classList.add('show-confirm-popup');
  }

  getElementSelector() {
    const feedSelector = window.kudago.flavour === 'mobile' ? '.page-feed' : '.feed';
    return `${feedSelector} [${TYPE_ATTRIBUTE}="${this.type}"][${ID_ATTRIBUTE}="${this.id}"]`;
  }

  getElement() {
    return q(this.getElementSelector());
  }

  bindSubmitButtonClick() {
    delegate(document.body, 'click', '.voting-button', (e) => {
      const id = e.delegateTarget.closest('.post').getAttribute(ID_ATTRIBUTE);
      if (this.id === id) {
        this.activate();
      }
    });
  }

  bindCloseButtonClick() {
    delegate(document.body, 'click', '.awardPopup-close', (e) => {
      const target = e.delegateTarget;
      const popup = target.closest('.votingPopup, .confirmEmailPopup');
      popup.classList.add('awardPopup--hidden');
    });
  }

  render(disabled = false) {
    const button = q('.voting-button', this.getElement());

    if (disabled) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }

    q('.voting-countContent', this.getElement()).textContent = `${Math.round(this.percent * 100) / 100}%`;
  }
}

module.exports = VotingItem;
